const wikiPages = [
  "Cristiano_Ronaldo",
  "United_States",
  "Apple_Inc.",
  "Paris",
  "Apollo_11",
  "ChatGPT",
  "Mango",
  "LeBron_James",
  "MrBeast",
  "Lion",
  "Nike,_Inc.",
  "Wrestling",
  "Burj_Khalifa",
  "Wood",
  "Dumbbell",
  "Friends",
  "Leonardo_DiCaprio",
  "Pikachu",
  "Superman",
  "Tic-tac-toe",
  "Tulip",
  "Table_tennis",
];

export default wikiPages;
